import buildApp from "./app";
import {createMetaManager} from "vue-meta"
import "@/services/presenceSocket";

import Toast, { POSITION } from "vue-toastification";

import "vue-toastification/dist/index.css";

import VueTippy from "vue-tippy";

import "tippy.js/dist/tippy.css"; // Tippy.js styles

import { createVuetify } from 'vuetify'



import * as components from 'vuetify/components'



import * as directives from 'vuetify/directives'



import { aliases, fa } from 'vuetify/iconsets/fa'





import "@fortawesome/fontawesome-free/css/all.css";

import "@fortawesome/fontawesome-free/js/all.js";



import 'vue-final-modal/style.css'

import "./toast-custom.css";
import clickOutside from "./utils/clickOutside.js";



const { app, router, store } = buildApp();


const metaManager = createMetaManager()






const vuetify = createVuetify({



  components,



  directives,



  icons: {



    defaultSet: 'fa',



    aliases,



    sets: {



      fa,



    },



  },



})





app.config.globalProperties.$silentPageRefresh = function () {

  location.replace(window.location.href);

};





app.use(vuetify)



app.use(metaManager)
app.use(Toast, {

  position: POSITION.TOP_CENTER,

  maxToasts: 1,

  newestOnTop: true,

  transition: "Vue-Toastification__bounce", // ya custom transition

  timeout: 2000,

  draggable: true,

});

app.directive("click-outside", clickOutside);

app.use(VueTippy);


router.isReady().then(() => {

  app.mount("#app", true);

});

